import { useState, useEffect } from 'react';

/**
 * Detects whether the app is running as an installed PWA (standalone mode).
 * Returns true when the app was launched from the home screen / app icon.
 */
export function usePWAMode() {
  const [isPWA, setIsPWA] = useState(() => checkStandalone());

  useEffect(() => {
    const mq = window.matchMedia('(display-mode: standalone)');
    const handler = (e) => setIsPWA(e.matches || navigator.standalone === true);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return isPWA;
}

function checkStandalone() {
  if (typeof window === 'undefined') return false;
  // iOS Safari
  if (navigator.standalone === true) return true;
  // Standard browsers
  if (window.matchMedia('(display-mode: standalone)').matches) return true;
  return false;
}
